





























import {DATE_FORMAT, i18n} from '@/components/DatePicker';
import moment from 'moment';
import Pikaday from 'pikaday';
import {Component, Prop, Vue} from 'vue-property-decorator';

export interface DateRange {
    start: Date;
    end: Date;
}

@Component
export default class DateRangeControl extends Vue {
    @Prop({type: Object, default: null})
    public readonly defaultDateRange: DateRange | null;

    protected filledStartDateValue: string = '';
    protected filledEndDateValue: string = '';

    private pikadayStartDate: Pikaday;
    private pikadayEndDate: Pikaday;

    private preventSubmit: boolean = true;

    public created() {
        if (this.defaultDateRange !== null) {
            this.filledStartDateValue = moment(this.defaultDateRange.start).format(DATE_FORMAT);
            this.filledEndDateValue = moment(this.defaultDateRange.end).format(DATE_FORMAT);
        }
    }

    public mounted(): void {
        this.pikadayStartDate = new Pikaday({
            format: DATE_FORMAT,
            i18n,
            field: this.$refs.startDateInput as HTMLElement,
        });

        this.pikadayEndDate = new Pikaday({
            format: DATE_FORMAT,
            i18n,
            field: this.$refs.endDateInput as HTMLElement,
        });

        this.preventSubmit = false;
    }

    public beforeUnmount(): void {
        this.pikadayStartDate.destroy();
        this.pikadayEndDate.destroy();
    }

    protected onStartDateChange(event: any) {
        this.filledStartDateValue = event.target.value;

        this.emitDateRangeChanged();
    }

    protected onEndDateChange(event: any) {
        this.filledEndDateValue = event.target.value;

        this.emitDateRangeChanged();
    }

    protected emitDateRangeChanged() {
        if (this.preventSubmit) {
            return;
        }

        if (this.filledStartDateValue === '' || this.filledEndDateValue === '') {
            return;
        }

        this.$emit('change', {
            start: moment(this.filledStartDateValue, DATE_FORMAT).toDate(),
            end: moment(this.filledEndDateValue, DATE_FORMAT).toDate(),
        });
    }
}
